<div [ngClass]=AppConfig.theme>
  <nav mat-tab-nav-bar color="primary">
    <a mat-tab-link [routerLink]="['/courses', { status: 'READY' }]" [active]="filter === 'READY'">준비중 강좌</a>
    <a mat-tab-link [routerLink]="['/courses', { status: 'INPROGRESS' }]" [active]="filter === 'INPROGRESS'">진행중 강좌</a>
    <a mat-tab-link [routerLink]="['/courses', { status: 'CLOSE' }]" [active]="filter === 'CLOSE'">종료 강좌</a>
  </nav>
</div>

<div class="flex-container p-4" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start start" fxLayoutWrap="wrap">
  <app-course *ngFor="let course of courses | async" [course]="course" fxFlex="25%" fxFlex.sm="50%" class="w-100"></app-course>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-list/course-list.component.html